import chalk, { type ChalkInstance } from 'chalk';

// LogLine is the v2 API wire shape returned by GET /api/v2/runtimes/:id/logs
export interface LogLine {
  pod: string;
  service: string | null;
  ts: string;       // ISO 8601
  line: string;
}

const PALETTE: ChalkInstance[] = [
  chalk.cyan,
  chalk.green,
  chalk.yellow,
  chalk.magenta,
  chalk.blue,
  chalk.redBright,
];

export class ServiceColorMap {
  private map = new Map<string, number>();
  private width = 0;

  /** Returns a stable identifier (for tests) keyed by service; internally stores palette index. */
  colorFor(service: string): string {
    if (!this.map.has(service)) {
      this.map.set(service, this.map.size % PALETTE.length);
      if (service.length > this.width) this.width = service.length;
    }
    return String(this.map.get(service));
  }

  colorize(service: string, text: string): string {
    this.colorFor(service);
    const idx = this.map.get(service)!;
    return PALETTE[idx](text);
  }

  columnWidth(): number {
    return this.width;
  }
}

function formatLocalTime(iso: string): string {
  const d = new Date(iso);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const ss = String(d.getSeconds()).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}

export function renderLine(
  entry: LogLine,
  colors: ServiceColorMap,
  opts: { verbose: boolean },
): string {
  const key = entry.service || entry.pod;
  const label = opts.verbose ? entry.pod : key;
  colors.colorFor(key); // register to update width
  const padded = label.padEnd(colors.columnWidth());
  const colored = colors.colorize(key, padded);
  const ts = formatLocalTime(entry.ts);
  return `${colored}  ${ts}  ${entry.line}`;
}
